var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{attrs:{"width":"200","height":"85","type":"bar","options":_vm.chartDetails.options,"series":_vm.chartDetails.series}})}
var staticRenderFns = []

export { render, staticRenderFns }